import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as React from 'react'
import { generatePath, Link, useRouteMatch } from 'react-router-dom'
import { DataList } from 'uxp/components'
import { IDefaultUIProps } from '../..'
import { hasValue } from '../../util'
import { generateIconProp } from '../common/icon-selector/IconEditor'
import Layout from './Layout'
import './Widgets.scss'

interface IWidgetsListProps extends IDefaultUIProps {
}

const WidgetsList: React.FunctionComponent<IWidgetsListProps> = props => {

    let { uxpContext } = props
    let { path } = useRouteMatch()

    let [showSelector, setShowSelector] = React.useState(false)


    async function getPaginated(max: number, lastToken: string) {
        return new Promise<{ items: any[], pageToken: string }>((done, nope) => {
            let last = 0
            if (lastToken) last = Number(lastToken)

            uxpContext.executeService('UXP', 'CardTemplate:Search', { max, last }, { json: true })
                .then(res => {
                    let items = res
                    if (last == 0) {
                        items.unshift({
                            "Key": "add_new_item",
                            "Description": 'Create a new widget'
                        })
                    }
                    done({ items: items, pageToken: last + (res.length).toString() })
                })
                .catch(e => {
                    done({ items: [], pageToken: lastToken })
                    console.log('unable to get paginated ', e);

                })
        })
    }

    function renderItem(item: any, key: number) {
        if (item.Key == 'add_new_item') {
            return <div className="designer-item-thumbnail add-new" onClick={() => { setShowSelector(true) }}>
                <div className="icon-container">
                    <div className="icon">
                    </div>
                </div>
                {
                    hasValue(item.Description) &&
                    <div className="description">{item.Description}</div>
                }
            </div>
        }
        return <Link to={generatePath(path + '/edit/:id', { 'id': item.Key })}>
            <div className="designer-item-thumbnail">
                <div className="icon-container">
                    <div className="icon">
                        <FontAwesomeIcon icon={generateIconProp(item.Icon)} />
                    </div>
                    <div className="name"> {item.Name}</div>
                </div>
                {
                    hasValue(item.Description) &&
                    <div className="description">{item.Description}</div>
                }
            </div>
        </Link>
    }

    return <Layout
        uxpContext={uxpContext}
        showSelector={showSelector}
        onCloseSelector={() => { setShowSelector(false) }}
    >

        <div className="widget-list-container">

            <DataList
                data={getPaginated}
                pageSize={50}
                renderItem={renderItem}
                showFooter={false}
                showEndOfContent={false}
            />

        </div>

    </Layout>
}

export default WidgetsList